const reactBackendEnv = (): string => {
  const { REACT_APP_BACKEND_URL } = (window as any)._env_ || process.env;
  console.log('window: ', (window as any)._env_);
  console.log('process.env: ', process.env);
  return REACT_APP_BACKEND_URL || 'http://localhost:3001';
};
export const reactBackendUrl = reactBackendEnv();

export const evotorBackendUrl = 'https://api.evotor.ru';